import { React, useEffect } from '@digsup/core-ui';
import PropTypes from 'prop-types';
import scrollIntoView from 'scroll-into-view';

export const Homepage = ({ targetId, children }) => {
  useEffect(() => {
    if (targetId) {
      scrollIntoView(document.getElementById(targetId));
    }
  });

  return <div>{children}</div>;
};

Homepage.propTypes = {
  targetId: PropTypes.oneOf(['pricing', 'features']),
  children: PropTypes.any,
};
